import { mountApp } from '@/lib/helpers';

import App from './app.vue';
import { learning } from '@/lib/learning';

mountApp('[data-offcanvas]', 'offcanvas', App, (_app, jsParams) => {
	learning.loadItems(jsParams['learning']);
});
